const local = {
  domain: "localhost",
  domain_secure: false,
  login_url: 'http://localhost:3001',
  ga_analytics: '',
  s3: {
    BUCKET: "files.fleet.neokodelabs.com"
  },
  apiGateway: {
    REGION: "us-east-1",
    URL: "https://api.fleet.neokodelabs.com"
  },
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_5VsTpB8bg",
    APP_CLIENT_ID: "fdgu6arr80mql74bc1pciq7ga",
    IDENTITY_POOL_ID: "us-east-1:214df7a4-ba0a-4899-850b-42fe1654cf9d"
  },
  websocket: {
    //URL: "http://34.222.48.241:8000"
    //URL: "http://18.236.84.213:8000"
    //URL: "http://localhost:8000"
    URL: "https://wss.fleet.neokodelabs.com"
  },
  API_GOOGLE_MAPS: 'AIzaSyC1CWqE4DTRICoXgMGZXrRYnxl3rGmFDuA',
  terms: 'https://fleet.neokodelabs.com/terms',
  policy: 'https://fleet.neokodelabs.com/policy'
};

const dev = {
  domain: "neokodelabs.com",
  domain_secure: true,
  login_url: 'https://admin.neokodelabs.com',
  ga_analytics: '',
  s3: {
    BUCKET: "files.fleet.neokodelabs.com"
  },
  apiGateway: {
    REGION: "us-east-1",
    URL: "https://api.fleet.neokodelabs.com"
  },
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_5VsTpB8bg",
    APP_CLIENT_ID: "fdgu6arr80mql74bc1pciq7ga",
    IDENTITY_POOL_ID: "us-east-1:214df7a4-ba0a-4899-850b-42fe1654cf9d"
  },
  websocket: {
    URL: "https://wss.fleet.neokodelabs.com"
  },
  API_GOOGLE_MAPS: 'AIzaSyC1CWqE4DTRICoXgMGZXrRYnxl3rGmFDuA',
  terms: 'http://fleet.neokodelabs.com/terms',
  policy: 'http://fleet.neokodelabs.com/policy'
};

const prod = {
  domain: "neokode.cl",
  domain_secure: true,
  ga_analytics: 'UA-140385946-4',
  login_url: 'https://admin.neokode.cl',
  s3: {
    BUCKET: "fleet.files.neokode.cl"
  },
  apiGateway: {
    REGION: "us-east-1",
    URL: "https://api.neokode.cl"
  },
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_J63UvvVq5",
    APP_CLIENT_ID: "2rkslsubkoung1igg4rb89ja2d",
    IDENTITY_POOL_ID: "us-east-1:3a1f114e-224d-42c8-9078-7c4b7ecc5ece"
  },
  websocket: {
    URL: "https://fleetws.neokode.cl"
  },
  API_GOOGLE_MAPS: 'AIzaSyC1CWqE4DTRICoXgMGZXrRYnxl3rGmFDuA',
  terms: 'https://www.neokode.cl/terms',
  policy: 'https://www.neokode.cl/policy'
};

const config = process.env.REACT_APP_ENV === 'production'
  ? prod
  : process.env.REACT_APP_ENV === 'development'
  ? dev
  : local;

console.log("REACT_APP_ENV:" + process.env.REACT_APP_ENV);

export default {
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config
};



// WEBPACK FOOTER //
// ./src/config.js